import React from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import BgTitle from "components/title/BgTitle";
import EmployeeDetailsMobileView from "./EmployeeDetailsMobileView";

export default ({ isXs = false }) => {
  if (isXs) return <EmployeeDetailsMobileView />;
  const { t } = useTranslation();

  // Use default cards if no cards prop is provided
  const displayCards = t("employee_links", { returnObjects: true });

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <BgTitle text={t("employee_headline")} />
      <Grid sx={{ mt: 4, mb: 4 }} container spacing={4}>
        {displayCards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              elevation={3}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                transition: "transform 0.2s",
                borderLeft: "2px solid #0c4d96",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
              }}
            >
              <CardContent
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    mb: 2,
                    fontWeight: "700",
                    color: "#0c4d96",
                    fontSize: "1rem",
                  }}
                >
                  {card.title}
                </Typography>

                <Button
                  sx={{ backgroundColor: "#0c4d96", fontSize: "0.8rem" }}
                  variant="contained"
                  color="primary"
                  href={card.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  fullWidth
                  endIcon={<OpenInNewIcon />}
                >
                  Open Link
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
